import React, { useContext } from 'react'
import { BI_AUT001Context } from '../context'
import { Col, Row } from 'reactstrap'
import TableSimpleDynamic from '../../../components/Dynamic/TableSimpleDynamic'
import { fnGetValueByKey } from '../../../helpers/functions'

export default function GridBody() {
  const {
    gridComponents,
    fnReplaceParamKeyWithFilteredValue,
    paramsOnFilter,
    triggerOnFilter,
    setTriggerOnFilter,
    inputGlobalSearchValue,
    setFilteredData
  } = useContext(BI_AUT001Context)

  const tabela = gridComponents.BODY[0]?.Childrens?.find(
    item => item.Chave_Transacao_Componente === 'TABELA_RESULTADOS_GRID_001'
  )

  const tabela2 = gridComponents.BODY[0]?.Childrens?.find(
    item => item.Chave_Transacao_Componente === 'TABELA_RESULTADOS_GRID_002'
  )

  const textoRodape1 = gridComponents.BODY[0]?.Childrens?.find(
    item => item.Chave_Transacao_Componente === 'TEXTO_RODAPE_TABELA_001'
  )

  return (
    <React.Fragment>
      <Row>
        {tabela?.Childrens && (
          <Col lg={12}>
            <TableSimpleDynamic
              data={tabela?.Childrens}
              fnReplaceParamKeyWithFilteredValue={
                fnReplaceParamKeyWithFilteredValue
              }
              paramsOnFilter={paramsOnFilter}
              triggerOnFilter={triggerOnFilter}
              setTriggerOnFilter={setTriggerOnFilter}
              inputSearchValue={inputGlobalSearchValue}
              enableDataSharing={true}
              onFilteredDataChange={setFilteredData}
            />
          </Col>
        )}
        {tabela2?.Childrens && (
          <Col lg={12} className='mt-3'>
            <TableSimpleDynamic
              data={tabela2?.Childrens}
              fnReplaceParamKeyWithFilteredValue={
                fnReplaceParamKeyWithFilteredValue
              }
              paramsOnFilter={paramsOnFilter}
              triggerOnFilter={triggerOnFilter}
              setTriggerOnFilter={setTriggerOnFilter}
              inputSearchValue={inputGlobalSearchValue}
              enableDataSharing={true}
              onFilteredDataChange={setFilteredData}
            />
          </Col>
        )}

        { textoRodape1 && (
          <div className="px-2">
            <div className="d-flex container-left-paginator align-items-center bg-info rounded-3 p-0 m-0 gap-4">
              <div
                style={{ width: 150, height: 50 }}
                className="d-flex font-size-12 text-black bg-light-gray-03 px-3 rounded-start-3 text-center align-items-center justify-content-center"
              >
                <span className="text-primary fw-bold">
                  {fnGetValueByKey(textoRodape1?.Childrens, "TITULO")}
                </span>
              </div>
              <div className="d-flex align-items-center gap-3">
                {JSON.parse(fnGetValueByKey(textoRodape1?.Childrens, "PROCEDURE_RESULTSET"))?.map((item, index) => (
                  <div
                    key={index}
                    className="font-size-12 font-w-400 text-dark-gray-primary"
                  >
                    {Object.values(item)[0]}{" "}
                    <span className="text-primary fw-bold">
                      {Object.values(item)[1]}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )
        }
      </Row>
    </React.Fragment>
  )
}
